import { render, staticRenderFns } from "./AppNotifyPage.vue?vue&type=template&id=cd2d0f30&scoped=true"
import script from "./AppNotifyPage.vue?vue&type=script&lang=js"
export * from "./AppNotifyPage.vue?vue&type=script&lang=js"
import style0 from "./AppNotifyPage.vue?vue&type=style&index=0&id=cd2d0f30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2d0f30",
  null
  
)

export default component.exports